import React from 'react';
import { useWrappedUrqlMutation } from 'toolbox';
import { AnimatePresence, motion } from 'framer-motion';

interface ErrorMessageProps extends ReturnType<typeof useWrappedUrqlMutation> {}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ errorMessage }) => {
  return (
    <AnimatePresence>
      {errorMessage && (
        <motion.p
          className="font-semibold tracking-tighter text-red-800"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
        >
          {errorMessage}
        </motion.p>
      )}
    </AnimatePresence>
  );
};

export default ErrorMessage;
